import { useQuery } from "@tanstack/react-query";
import { Table } from "antd";
import { axiosInstance } from "../utils/api";

const Customize = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["customize-queries"],
    queryFn: async () => {
      const response = await axiosInstance.get("/admin/customize-queries");
      return response.data;
    },
  });

  const columns = [
    {
      title: "User Name",
      dataIndex: ["user", "name"],
    },
    {
      title: "User Email",
      dataIndex: ["user", "email"],
    },
    {
      title: "Product Name",
      dataIndex: ["productQuantity", "product", "name"],
    },
    {
      title: "Product SKU",
      dataIndex: ["productQuantity", "sku"],
    },
    {
      title: "Size",
      dataIndex: "size",
    },
    {
      title: "Color",
      dataIndex: "color",
    },
    {
      title: "Message",
      dataIndex: "message",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (value) => new Date(value).toLocaleDateString(),
    },
  ];

  return (
    <div className="p-5">
      <div className="bg-white border rounded-lg overflow-hidden">
        <div className="flex justify-between items-center px-5 py-3 bg-gray-100 border-b">
          <h1 className="text-lg font-medium">Customize Requests</h1>
        </div>
        <div className="p-5">
          <Table
            bordered
            rowClassName={(record, index) =>
              index % 2 !== 0 ? "bg-white" : "bg-gray-100"
            }
            columns={columns}
            dataSource={data}
            loading={isLoading}
            scroll={{ x: 1000 }}
          />
        </div>
      </div>
    </div>
  );
};

export default Customize;
